import { Injectable } from '@angular/core';
import { Configuration } from './configurator/configuration';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  configs: Configuration[] = [];
    
  constructor( private http: HttpClient ) { }
  
  loadSession(): Observable<any> {
    
    return this.http.get<any>( 'api/session' )
        .pipe( map( ( response ) => {
            this.configs = response.savedConfigurations;
        } )
    );
    
  }
  
  addConfiguration( config: Configuration ): void {
    
    let replaced = false;
    
    for (var i = 0, c; (c = this.configs[i]) && !replaced; i++) {
        
        if (c.id === config.id) {
            this.configs.splice( i, 1, config);
            replaced = true;
        }
    }
    
    if (!replaced) {
        this.configs.push( config );
    }
  }
  
  deleteConfiguration( config: Configuration ): Observable<any> {
    
    return this.http.delete<any>( 'api/session/configuration/' + config.id)
        .pipe( map( ( response ) => {
            this.configs = response.savedConfigurations;
        } ) );
  }
  
}
